import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ProcedureSectionVisibilityService } from '@shared/services/procedure-section-visibility.service';
import { IS_NOTES_VISIBLE$ } from '@shared/services/sections-visibility.tokens';

@Injectable()
export class ProcedureSelectedPageFacade {
	readonly isApplianceProcedureSectionVisible$: Observable<boolean> = this.sectionVisibilityService.applianceSectionVisible$;
	readonly isScanSurgicalGuideSectionVisible$: Observable<boolean> = this.sectionVisibilityService.scanSurgicalGuideSectionVisible$;
	readonly isDentureDetailsVisible$: Observable<boolean> = this.sectionVisibilityService.dentureDetailsVisible$;
	readonly isInvisalignDetailsVisible$: Observable<boolean> = this.sectionVisibilityService.isInvisalignDetailsVisible$;
	readonly isToothDiagramVisible$: Observable<boolean> = this.sectionVisibilityService.isTeethDiagramAreaVisible$;
	readonly isSendToIDSMessageVisible$: Observable<boolean> = this.sectionVisibilityService.isSendToIDSMessageVisible$;
	readonly isArtProcedureSelected$: Observable<boolean> = this.sectionVisibilityService.isArtProcedureSelected$;
	
	constructor(
		private readonly sectionVisibilityService: ProcedureSectionVisibilityService,
		@Inject(IS_NOTES_VISIBLE$) readonly isNotesVisible$: Observable<boolean>
	) {}
}
